import React from 'react'
import PropTypes from 'prop-types'
import { getInitials } from '@util/stringUtil'
import { Container, Title } from './styles'

const Avatar = ({ name, imageBase64 }) => (
  <Container>
    {imageBase64 ? (
      <img
        src={`data:image/jpeg;base64,${imageBase64}`}
        alt={name}
        style={{ width: 40, height: 40, borderRadius: '50%' }}
        loading="lazy"
      />
    ) : (
      <Title>{getInitials(name)}</Title>
    )}
  </Container>
)

Avatar.propTypes = {
  name: PropTypes.string,
  imageBase64: PropTypes.string,
}
Avatar.defaultProps = { name: '', imageBase64: null }
export default Avatar
